import { createSlice } from "@reduxjs/toolkit";

const arrivalTimerSlice = createSlice({
  name: "arrivalTimer",
  initialState: {
    elapsed: 0,
    running: false,
  },
  reducers: {
    startTimer: (state) => {
      state.running = true;
    },
    stopTimer: (state) => {
      state.running = false;
    },
    resetTimer: (state) => {
      state.elapsed = 0;
    },
    tickTimer: (state) => {
      if (state.running) {
        state.elapsed += 1;
      }
    },
    updateTimer: (state, action) => {
      state.elapsed = action.payload;
    },
  },
});

export const { startTimer, stopTimer, resetTimer, tickTimer, updateTimer } = arrivalTimerSlice.actions;
export const selectIsTimerRunning = (state) => state.arrivalTimer.running;
export const selectIsTimerObj = (state) => state.arrivalTimer;
export default arrivalTimerSlice.reducer;
